import { handleActions } from 'redux-actions';
import * as R from 'ramda';
import {
  FETCH_OPPORTUNITY,
  FETCH_OPPORTUNITIES,
  UPDATE_OPPORTUNITY,
  CURRENT_OPPORTUNITY_RESET,
  OPPORTUNITIES_FILTER_SET
} from '../../constants/Constants';

const initialState = { items: [], filter: null, currentOpportunity: {} };

const getDisplayStatus = (x, when) => {
  const from = x.displayedFrom;
  const to = x.displayedTo;
  if (from && from > when) {
    return {
      status: 1,
      timestamp: from
    };
  }
  if (to && to < when) {
    return {
      status: 2,
      timestamp: to
    }
  }
  return {
    status: 0,
    timestamp: from || x.createdAt || when
  };
};

const createDisplayComparator = () => {
  const now = Date.now();
  return (a, b) => {
    const dsa = getDisplayStatus(a, now);
    const dsb = getDisplayStatus(b, now);

    const numA = dsa.status !== dsb.status ? dsa.status : -dsa.timestamp;
    const numB = dsa.status !== dsb.status ? dsb.status : -dsb.timestamp;
    return numA < numB ? -1 : (numA > numB ? 1 : 0);
  };
};

export default handleActions(
  {
    [FETCH_OPPORTUNITIES.SUCCESS]: (state, { payload: { items } }) => ({
      ...state,
      items: R.sortWith([createDisplayComparator()])(items)
    }),
    [FETCH_OPPORTUNITY.SUCCESS]: (state, { payload: { payload } }) => ({ ...state, currentOpportunity: payload }),
    [UPDATE_OPPORTUNITY.SUCCESS]: (state, { payload: { payload } }) => ({
      ...state,
      currentOpportunity: payload,
      currentOpportunitySaving: false
    }),
    [CURRENT_OPPORTUNITY_RESET]: state => ({ ...state, currentOpportunity: {} }),
    [OPPORTUNITIES_FILTER_SET]: (state, { payload }) => ({ ...state, filter: payload }),
  },
  initialState
);




// WEBPACK FOOTER //
// ./src/reducers/entities/OpportunitiesReducer.js